import $ from 'jquery';
class Sticky {

	constructor(element) {
		$(document).ready(() => this.load());
	}

	load() {
		this.stickyscroll = $('.sticky-when-scroll');
		if(this.stickyscroll.length) {
			$(window).scroll(() => this.sticky_relocate());
			this.sticky_relocate();
		}
	}

	sticky_relocate() {

		this.stickyscroll.each((index,el) => {
			console.log($(el).data("top"))
			if($(window).scrollTop() > $(el).data("top") ) {
				$(el).addClass('sticky');
			} else {
				$(el).removeClass('sticky');
			}
			//
			// if ($(window).scrollTop() > $div.data("top") ) {
			// 	$div.addClass('sticky');
			// } else {
			// 	$div.removeClass('sticky');
			// }
		})
	}
}

new Sticky